<div [ngClass]="popupBodyClass" class="modal-v2">
  <div class="modal-v2__head">
    <div class="modal-v2__head--title">{{ title }}</div>
    @if (!hideCloseBtn) {
      <app-icon-button-v2
        (btnClick)="onClose()"
        [disabled]="false"
        [isLoading]="false"
        type="transparent"
        color="tertiary"
        icon="icon-v2-close"
        size="small"
      ></app-icon-button-v2>
    }
  </div>
  <div class="modal-v2__body">
    <div class="modal-v2__scroll">
      <ng-template #popupContainer></ng-template>
    </div>
  </div>
</div>
